/**
 * Landing page email button constants, shared by the guest send action and the public button.
 */

/** `email_send_log.kind` for a send a guest triggers by clicking a landing page email button. */
export const EMAIL_BUTTON_SEND_KIND = "landing_page_button";

/**
 * Fixed cooldown window. A person gets at most one send per template per window; the window index
 * is part of the send's dedupe key, so the unique `dedupe_key` rejects a repeat atomically.
 */
export const EMAIL_BUTTON_SEND_WINDOW_MS = 10 * 60 * 1000;

/** Most button emails one person may receive per event within {@link EMAIL_BUTTON_HOURLY_CAP_WINDOW_MS}, in any status. */
export const EMAIL_BUTTON_HOURLY_CAP = 5;

/** Look-back window for {@link EMAIL_BUTTON_HOURLY_CAP}. */
export const EMAIL_BUTTON_HOURLY_CAP_WINDOW_MS = 60 * 60 * 1000;

/** Per-instance burst filter on send attempts, keyed by the viewer's verified email. Not the real cap. */
export const EMAIL_BUTTON_BURST_RATE_LIMIT = { windowMs: 60 * 1000, maxCalls: 5 };

/** How long the public button shows its sent state before returning to idle. */
export const EMAIL_BUTTON_SENT_STATE_MS = 4000;

/** Longest first, last, or full name passed to a button send. */
export const EMAIL_BUTTON_NAME_MAX_LENGTH = 100;

/** Longest button id the send action accepts. Button ids are UUIDs or short legacy ids. */
export const EMAIL_BUTTON_ID_MAX_LENGTH = 128;

/**
 * `hotel_booking_responses.status` values whose confirmation number and dates may go into a sent
 * email. An allowlist, so a `draft` (an abandoned half-filled form), a `rejected` booking, and any
 * status added later stay out until someone decides they belong.
 */
export const LIVE_BOOKING_STATUSES = ["confirmed", "submitted"] as const;

/**
 * Most rows read when looking up one guest's booking by email. The query is already bounded to the
 * event and the stored domain family; this caps the scan on an event where everyone shares a domain.
 */
export const EMAIL_BUTTON_BOOKING_CANDIDATE_LIMIT = 200;
